import { render, staticRenderFns } from "./header-user.vue?vue&type=template&id=3041b254&scoped=true&"
import script from "./header-user.vue?vue&type=script&lang=js&"
export * from "./header-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3041b254",
  null
  
)

export default component.exports